// extracted by mini-css-extract-plugin
export default {"blob":"blobs_blob__9X+qv"};